import { useState } from "react";
import { Tooltip, IconButton } from "@mui/material";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import { useTranslation } from "react-i18next";

import AppContext from "../../../Contexts/AppContext";
import { useContext } from "react";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";

const TeledetectionButtonTool = ({ layer }) => {
  const { t } = useTranslation("main");
  const {
    // setIsCustomLayerGroupModeActive,
    // customLayerGroupModeOptions,
    // setCustomLayerGroupModeOptions,
    modeOptions,
    // setModeOptions,
    enterTeledetecionMode,
    exitTeledetecionMode,
  } = useContext(AppContext);

  const isTeledecting = modeOptions.ASBESTOS_CLICK.includes(layer.id);
  // console.log("TeledetectionButtonTool", layer);
  // console.log("TeledetectionButtonTool modeOptions", modeOptions);

  const toggleIsCustomLayerGroupMode = () => {
    console.log("toggleIsCustomLayerGroupMode");
    if (isTeledecting) {
      console.log("exitTeledetecionMode X");
      exitTeledetecionMode(layer);
    } else {
      console.log("enterTeledetecionMode X");
      enterTeledetecionMode(layer);
    }
    // function toggleElement(array, element) {
    //   const newArray = [...array];
    //   const index = array.indexOf(element);
    //   if (index === -1) {
    //     newArray.push(element); // Si no está, lo agrega
    //   } else {
    //     newArray.splice(index, 1); // Si está, lo elimina
    //   }

    //   return newArray;
    // }

    // const newCustomLayerGroupModeOptions = { ...customLayerGroupModeOptions };
    // // layer_group.is_teledetecting = !layer_group.is_teledetecting;

    // setIsCustomLayerGroupModeActive((prev) => !prev);
    // setCustomLayerGroupModeOptions((prev) => ({
    //   ...prev,
    //   onMapClickControl: !customLayerGroupModeOptions.onMapClickControl,
    // }));

    // setModeOptions((prev) => ({
    //   ...prev,
    //   ASBESTOS_CLICK: toggleElement(prev.ASBESTOS_CLICK, layer.id),
    // }));
  };

  return (
    <Tooltip title={t("tooltipTeledeteccion")}>
      <IconButton
        className={
          // !customLayerGroupModeOptions.onMapClickControl
          isTeledecting
            ? "layerGroupTool-element-selected"
            : "layerGroupTool-element"
        }
        onClick={toggleIsCustomLayerGroupMode}
      >
        <AddLocationAltIcon />
      </IconButton>
    </Tooltip>
  );
};
export { TeledetectionButtonTool };
